import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";

const programSupportsPatientLinking = () => true;

export const usePatientLinkingEnabled = () => {
  const [flagEnabled] = useFeatureFlag(featureFlags.epocus.patientLinking);
  return Boolean(flagEnabled) && programSupportsPatientLinking();
};
